export default {
  data() {
    return {
      scrollPosition: 0,
      scrollKey: null,
      scrollListener: null
    };
  },
  computed: {
    scrollStorageKey() {
      return this.scrollKey || `scrollPos_${this.$route.path}`;
    },
  },
  methods: {
    saveScrollPosition() {
      const position = window.pageYOffset || document.documentElement.scrollTop;
      sessionStorage.setItem(this.scrollStorageKey, position.toString());
    },
    async restoreScrollPosition() {
      const savedPosition = sessionStorage.getItem(this.scrollStorageKey);
      if (savedPosition) {
        await this.$nextTick();
        requestAnimationFrame(() => {
          window.scrollTo(0, parseInt(savedPosition, 10));
          setTimeout(() => {
            window.scrollTo(0, parseInt(savedPosition, 10));
          }, 100);
        });
      } else {
        window.scrollTo(0, 0);
      }
    },
    clearScrollPosition() {
      sessionStorage.removeItem(this.scrollStorageKey);
    },
  },
  mounted() {
    this.scrollListener = () => this.saveScrollPosition();
    window.addEventListener('scroll', this.scrollListener, { passive: true });
  },
  beforeDestroy() {
    if (this.scrollListener) {
      window.removeEventListener('scroll', this.scrollListener);
    }
  },
};
